import React from 'react';
import Login from '../Login';
import LoginPage from '../LoginPage';

export default ({ children, user })=> {
	return user ? children : user === undefined ? <div/> : <LoginPage><Login/></LoginPage>;
}